import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { UserIconReact } from 'common/widgets/user-icon';
import { useCurrentUser } from 'common/contexts/react/current-user-context';
import { IconSizeType } from 'common/constants';
import { getProfilePath } from 'common/report/util/profile/utils';
import styles from './index.module.styl';
export function SessionReplayHomeHeader() {
  const {
    t
  } = useTranslation();
  const currentUser = useCurrentUser().get().value;
  return <div className={styles.container} data-sentry-component="SessionReplayHomeHeader" data-sentry-source-file="index.tsx">
      <div className={styles.titleText}>{t("mixology.app.session_replay")}</div>
      <div className={styles.settingIconsContainer}>
        <UserIconReact id={currentUser === null || currentUser === void 0 ? void 0 : currentUser.id} size={IconSizeType.Small} name={currentUser === null || currentUser === void 0 ? void 0 : currentUser.name} email={currentUser === null || currentUser === void 0 ? void 0 : currentUser.email} disable-sidebar onClick={() => {
        const profileUrl = getProfilePath(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, null);
        window.location.href = profileUrl;
      }} data-sentry-element="UserIconReact" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
}